import React from "react";
import Image from "next/image";
import styles from "./index.module.scss";
import { useTranslation } from "next-i18next";
import { useWidth } from "@/utils/resize";
import buriedsdk from "@/utils/zz-buried/index";
import { Pagination } from "antd";

import down from "@images/ic_drop_down@2x.png";

type Props = {
  current: number;
  total: number;
  size: number;
  type?: string;
  pageSizeOptions?: any
};

const Index = (props: Props) => {
  const { width, display } = useWidth();
  const { current, total, size, pageSizeOptions, type } = props as any;

  function showTotal(total) {
    return `Total ${total}`;
  }

  const changePage = (page, pageSize) => {
    const pathname = window.location.pathname
    if (type == 'params') {
      window.location.href = `/posts/category?pageSize=${pageSize}&pageNum=${page}`;
    } else {
      window.location.href = `${pathname}?page=${page}&size=${pageSize}`;
    }
  };

  return (
    <div className={styles.pagination}>
      <Pagination
        className="w-full flex flex-wrap justify-center lg1024:justify-start"
        size="small"
        current={current}
        total={total}
        pageSize={size}
        showSizeChanger
        showQuickJumper
        pageSizeOptions={pageSizeOptions || [8, 16, 24, 32]}
        showTotal={showTotal}
        onChange={(page, pageSize) => {
          changePage(page, pageSize);
        }}
        itemRender={(page, type, originalElement) => {
          if (type === "prev") {
            return (
              <div className={styles["page-content"] + " rotate-90"}>
                <Image width={10} height={10} src={down}></Image>
              </div>
            );
          } else if (type === "next") {
            return (
              <div className={styles["page-content"] + " -rotate-90"}>
                <Image width={10} height={10} src={down}></Image>
              </div>
            );
          } else if (type === "page") return originalElement;
        }}
      />
    </div>
  );
};
export default Index;
